import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// One file per page or area (namespace) and language, so pages can be translated one at a time
// without touching each other's text. The namespaces are listed in locales/<lng>/index.js. To
// translate a page, see README.md next to this file.
import en from './locales/en';
import es from './locales/es';

export const LANGUAGES = ['es', 'en'];
export const DEFAULT_LANGUAGE = 'es';

// The language tag Intl should use for dates, numbers and money, so "es" formats the way
// Spanish speakers in the US read them, with $ for dollars.
const INTL_LOCALES = { es: 'es-US', en: 'en-US' };

export const resources = { en, es };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: Object.keys(resources.en),
    defaultNS: 'common',
    // No `lng`: it would override the language the admin picked, which the detector reads back
    // from localStorage. Spanish is the default for anyone who hasn't picked one yet.
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGES,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false, // React escapes already
    },
    detection: {
      // Not the browser's language: most admins' browsers are in English, and the volunteers at
      // the door need Spanish unless they choose otherwise.
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'adminLanguage',
    },
    react: {
      useSuspense: false,
    },
  });

const syncHtmlLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
};
syncHtmlLang(i18n.resolvedLanguage || DEFAULT_LANGUAGE);
i18n.on('languageChanged', syncHtmlLang);

/** The Intl locale for the current language, e.g. for toLocaleString or Intl.NumberFormat. */
export const intlLocale = () => INTL_LOCALES[i18n.resolvedLanguage] || INTL_LOCALES[DEFAULT_LANGUAGE];

export default i18n;
